import Login from 'i18n/fr/Login';
import Offers from 'i18n/fr/Offers';
import DatesUnits from 'i18n/fr/DatesUnits';
import DownloadMobileApp from 'i18n/fr/DownloadMobileApp';
import General from 'i18n/fr/General.json';
import OfferDetail from 'i18n/fr/OfferDetail';
import Jobs from 'i18n/fr/Jobs';
import PendingJobDetail from 'i18n/fr/PendingJobDetail';
import InTransitJobDetail from 'i18n/fr/InTransitJobDetail';
import RecoverPassword from 'i18n/fr/RecoverPassword';
import Chat from 'i18n/fr/Chat';
import Banner from 'i18n/fr/Banner';
import Alerts from 'i18n/fr/Alerts';
import Pods from 'i18n/fr/Pods';
import AccountSettings from 'i18n/fr/AccountSettings';
import Documents from 'i18n/fr/Documents';

const lang = {
  Login,
  Offers,
  DatesUnits,
  DownloadMobileApp,
  General,
  Documents,
  OfferDetail,
  Jobs,
  PendingJobDetail,
  InTransitJobDetail,
  RecoverPassword,
  Chat,
  Banner,
  Alerts,
  Pods,
  AccountSettings
};

export default lang;
